import React, { useState, useEffect } from "react";
import Card from "../components/Card";

function LatestLaunch() {
  const [object, setObject] = useState({});
  const [loading, setLoading] = useState(true);

  async function getData() {
    try {
      setLoading(true);
      let response = await fetch(
        "https://api.spacexdata.com/v4/launches/latest"
      );
      let json = await response.json();
      setObject(json);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getData();
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Card
        loading={loading}
        missionName={object.name}
        missionDate={object.static_fire_date_utc}
        missionDetails={object.details}
        missionBadge={object.links?.patch?.small}
        missionImage={
          object.links?.flickr?.original[0] || object.links?.patch?.small
        }
      />
    </div>
  );
}

export default LatestLaunch;
